
import dialogDrag from "./dialogDrag"
// 统一入口
export default function directive(app) {
    app.directive('dialogDrag', dialogDrag)
}